import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlObras = '/service/materiais/obras/'

class DetalhesObrasParadasService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    consultar(filtro) {
        let data = {
            sequencia: filtro.sequencia,
        }

        return this.conex.post(urlObras + 'detalhesObrasParadas/', JSON.stringify(data))
    }
}

export default DetalhesObrasParadasService
